import moment from 'moment';
import { css } from 'glamor';
import * as PortfolioConstants from './constants';
import { DATE_FORMAT, REQUEST_DATE_FORMAT } from '../../constants';
import 'url-search-params-polyfill';
import {LegalConstitutionType} from './legalConstitutionTypeUtil'


export const updateAppliedFiltersFunction = (filterFormData, toDate, fromDate, selectedCountry, selectedState) => {

}

export const appliedPortfolioFilters = (filterFormData, toDate, fromDate, selectedCountry, selectedState) => {
    let appliedFilters = [];
    counterPartyNameFilter(filterFormData, appliedFilters);
    riskLevelFilter(filterFormData, appliedFilters);
    zoneFilter(filterFormData, appliedFilters);
    productNameFilters(filterFormData, appliedFilters);
    legalContitutionFilters(filterFormData, appliedFilters);
    businessSegmentsFilters(filterFormData, appliedFilters);
    caseStatusFilters(filterFormData, appliedFilters);
    riskTrendFilters(filterFormData, appliedFilters);
    caseTypeFilters(filterFormData, appliedFilters);
    selectedCountryFilter(selectedCountry, appliedFilters);
    selectedStateFilter(selectedState, appliedFilters);
    productTypeFilters(filterFormData, appliedFilters)
    if (toDate && fromDate) {
        appliedFilters.push({
            date: [
                {
                    label: moment(toDate).format(DATE_FORMAT),
                    key: PortfolioConstants.TO_DATE
                },
                {
                    label: moment(fromDate).format(DATE_FORMAT),
                    key: PortfolioConstants.FROM_DATE
                },
            ]
        });
    }
    return appliedFilters;
}

const selectedStateFilter = (selectedState, appliedFilters) => {
    if (selectedState) {
        if (selectedState.length > 0) {
            selectedState.forEach(item => {
                if (item.label) {
                    appliedFilters.push(item.label)
                } else {
                    appliedFilters.push(item)
                }
            })
            // appliedFilters.push(selectedState);
        }
    }
}

const selectedCountryFilter = (selectedCountry, appliedFilters) => {
    if (selectedCountry) {
        if (selectedCountry.length > 0) {
            appliedFilters.push(selectedCountry);
        }
    }
}

const counterPartyNameFilter = (filterFormData, appliedFilters) => {
    if (filterFormData.counterpartyType) {
        filterFormData.counterpartyType.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const riskLevelFilter = (filterFormData, appliedFilters) => {
    if (filterFormData.riskLevel) {
        filterFormData.riskLevel.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const zoneFilter = (filterFormData, appliedFilters) => {
    if (filterFormData.region) {
        filterFormData.region.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const productNameFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.reportType) {
        filterFormData.reportType.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

const legalContitutionFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.classOfCompany) {
        filterFormData.classOfCompany.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

const productTypeFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.productTypes) {
        filterFormData.productTypes.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

const businessSegmentsFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.businessSegment) {
        filterFormData.businessSegment.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const caseStatusFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.caseStatus) {
        filterFormData.caseStatus.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const riskTrendFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.riskTrend) {
        filterFormData.riskTrend.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

const caseTypeFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.caseType) {
        filterFormData.caseType.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

export const filterValueListRemove = (removeFilter, appliedFilterList) => {
    appliedFilterList.forEach((item, index, element) => {
        if (item === removeFilter) {
            appliedFilterList.splice(index, 1)
        }
    })
    return appliedFilterList
}

export const deleteAppliedFilterList = (removeFilter, appliedFilters, toDate, fromDate) => {
    deleteCounterPartyFilter(removeFilter, appliedFilters);
    deleteReportTypeFilter(removeFilter, appliedFilters);
    deleteRiskLevelFilter(removeFilter, appliedFilters);
    deleteZoneFilter(removeFilter, appliedFilters);
    // deleteProductNameFilter(removeFilter, appliedFilters);
    deleteLegalConstitutionFilter(removeFilter, appliedFilters);
    deleteBusinessSegment(removeFilter, appliedFilters);
    deleteRiskTrendFilter(removeFilter, appliedFilters);
    deleteCaseStatusFilter(removeFilter, appliedFilters);
    deleteCountryFilter(removeFilter, appliedFilters);
    deleteStateFilter(removeFilter, appliedFilters);
    deleteCaseTypeFilter(removeFilter, appliedFilters);
    if (toDate || fromDate) {
        deleteDateFilter(appliedFilters)
    }
    return appliedFilters
}

const deleteDateFilter = (appliedFilters) => {
    appliedFilters.toDate = null;
    appliedFilters.fromDate = null;
}

const deleteStateFilter = (removeFilter, appliedFilters) => {
    appliedFilters.selectedState.filter((currentValue, index, element) => {
        if (currentValue === removeFilter[0]) {
            element.splice(index, 1)
        }
    })
}

const deleteCountryFilter = (removeFilter, appliedFilters) => {
    appliedFilters.selectedCountry.filter((currentValue, index, element) => {
        if (currentValue === removeFilter[0]) {
            element.splice(index, 1)
        }
    })
}
const deleteCounterPartyFilter = (removeFilter, appliedFilters) => {
    appliedFilters.counterpartyType.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
}
const deleteReportTypeFilter = (removeFilter, appliedFilters) => {
    appliedFilters.reportType.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1)
        }
    })
}
const deleteRiskLevelFilter = (removeFilter, appliedFilters) => {
    appliedFilters.riskLevel.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }

    })
}
const deleteZoneFilter = (removeFilter, appliedFilters) => {
    appliedFilters.region.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
}
/* const deleteProductNameFilter = (removeFilter, appliedFilters) => {
    appliedFilters.productNameFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
} */
const deleteLegalConstitutionFilter = (removeFilter, appliedFilters) => {
    appliedFilters.classOfCompany.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
}
const deleteBusinessSegment = (removeFilter, appliedFilters) => {
    appliedFilters.businessSegment.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
}
const deleteRiskTrendFilter = (removeFilter, appliedFilters) => {
    appliedFilters.riskTrend.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
}
const deleteCaseStatusFilter = (removeFilter, appliedFilters) => {
    appliedFilters.caseStatus.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }
    })
}
const deleteCaseTypeFilter = (removeFilter, appliedFilters) => {
    appliedFilters.caseType.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            element.splice(index, 1);
        }

    })
}
export const portfolioDataHandle = (portfolioData) => {
    let tempPortfolioData = [], riskTrend, riskLevel;
    portfolioData.forEach((item, index, element) => {
        riskTrend = getRiskTrendClass(item);
        riskLevel = getRiskLevelClass(item);
        tempPortfolioData.push({
            counterpartyType: item.counterpartyType,
            id: item.computedReportId,
            counterpartyName: item.counterpartyName,
            counterpartyId: item.counterpartyId,
            riskScore: item.riskScore,
            riskScoreTrend: riskTrend,
            riskLevel: riskLevel,
            productName: item.productName,
            deliveryDate: item.deliveryDate,
            lastUpdateDate: item.lastUpdateDate,
            status: item.status,
            isChecked: false,
            zoneName: item.zoneName,
            gstNo: item.gstNo,
            panNo: item.panNo,
            cinNumber:item.cinNumber,
            computedReportId:item.computedReportId,

        })
    })
    return tempPortfolioData
}

export const getRiskLevelClass = (portFolioRiskLevelData) => {
    switch (portFolioRiskLevelData.riskLevel) {
        case PortfolioConstants.HIGH:
            return 'risk-indicator high'
        case PortfolioConstants.LOW:
            return 'risk-indicator low'
        case PortfolioConstants.MEDIUM:
            return 'risk-indicator medium'
        default: return 'risk-indicator none'
    }
}
export const getRiskTrendClass = (portfolioRiskTrendData) => {
    switch (portfolioRiskTrendData.riskScoreTrend) {
        case PortfolioConstants.UP:
            return 'ml-2 icon-long-arrow-up'
        case PortfolioConstants.DOWN:
            return 'ml-2 icon-long-arrow-down'
        case PortfolioConstants.STABLE:
            return 'ml-2 icon-arrow-bothside'
        default: return 'ml-2'
    }
}

export const SearchRequestBody = (searchType,value, portfolioData, toDate, fromDate, selectedCountry, selectedState, reportCategory, withoutRiskScore) => {
    let searchBody;
    if (toDate && fromDate) {
        toDate = moment(toDate).format(REQUEST_DATE_FORMAT); //DATE_FORMAT
        fromDate = moment(fromDate).format(REQUEST_DATE_FORMAT); //DATE_FORMAT
    }
    let searchText= (searchType === PortfolioConstants.SEARCH_PARAMETERS[0]) ? value : '';
    let searchGstNo= (searchType === PortfolioConstants.SEARCH_PARAMETERS[1]) ? value : '';
    let searchPanNo= (searchType === PortfolioConstants.SEARCH_PARAMETERS[2]) ? value : '';
    let searchCinNo= (searchType === PortfolioConstants.SEARCH_PARAMETERS[3]) ? value : '';
    if (portfolioData.length === 0) {
        searchBody = {
            searchString: searchText,
            gstNo:searchGstNo,
            panNo:searchPanNo,
            cinNumber:searchCinNo,
            counterpartyFilter: [],
            productNameFilter: [],
            riskLevelFilter: [],
            zoneFilter: [],
            legalConstitutionFilter: [],
            businessSegmentFilter: [],
            nicSegmentFilter: [],
            caseStatusFilter: [],
            riskScoreTrendFilter: [],
            toDate: toDate,
            fromDate: fromDate,
            countryFilter: '',
            stateFilter: '',
            caseTypeFilter: [],
            productTypes : [],
            reportCategory : reportCategory,
            withoutRiskScore: withoutRiskScore
        }
    } else {
        // let tempcountry; 
        let classOfCompany = LegalConstitutionType(portfolioData.classOfCompany);
        searchBody = {
            counterpartyFilter: portfolioData.counterpartyType,
            productNameFilter: portfolioData.reportType,
            riskLevelFilter: portfolioData.riskLevel,
            zoneFilter: portfolioData.region,
            legalConstitutionFilter: classOfCompany,
            businessSegmentFilter: portfolioData.businessSegment,
            nicSegmentFilter: portfolioData.nicSegment,
            caseStatusFilter: portfolioData.caseStatus,
            riskScoreTrendFilter: portfolioData.riskTrend,
            toDate: toDate,
            fromDate: fromDate,
            searchString: searchText,
            gstNo:searchGstNo,
            panNo:searchPanNo,
            cinNumber:searchCinNo,
            countryFilter: (portfolioData.selectedCountry) ? (portfolioData.selectedCountry.length > 0) ? portfolioData.selectedCountry : [] : [],
            stateFilter: (portfolioData.selectedState) ? (portfolioData.selectedState.length > 0) ? portfolioData.selectedState : [] : [],
            caseTypeFilter: portfolioData.caseType,
            productTypes : portfolioData.productTypes,
            reportCategory : reportCategory,
            withoutRiskScore: withoutRiskScore
        }
    }
    return searchBody
}

/* export const sortDataByKey = (key, portfolioSortableData, order) => {

    if (order) {
        portfolioSortableData.reverse(compareBy(key))
        portfolioSortableData.sort(compareBy(key));
    } else {
        portfolioSortableData.sort(compareBy(key))
        portfolioSortableData.reverse(compareBy(key));

    }
    return portfolioSortableData
}

const compareBy = (key) => {
    return function (a, b) {
        if (a[key] < b[key]) return 1;
        if (a[key] > b[key]) return -1;
        return 0;
    };
}

export const sortByDate = (key, portFolioDateSortableData, order) => {
    if (order) {
        sortDateAscendingOrder(key, portFolioDateSortableData)
    } else {
        sortDateDesendingOrder(key, portFolioDateSortableData)
    }
    return portFolioDateSortableData
}

const sortDateAscendingOrder = (key, portFolioDateSortableData) => {
    portFolioDateSortableData.reverse(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });
    portFolioDateSortableData.sort(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });;
    return portFolioDateSortableData
} */

const sortDateDesendingOrder = (key, portFolioDateSortableData) => {
    portFolioDateSortableData.sort(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });
    portFolioDateSortableData.reverse(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });
    return portFolioDateSortableData
}

export const checkAllCheckboxMethod = (portfolioData) => {
    let flag = true
    for (let i = 0; i < portfolioData.length; i++) {
        if (portfolioData[i].isChecked === false) {
            flag = false;
            break;
        } else {
            flag = true
        }
    }
    return flag
}

export const setCounterpartyList = (portfolioData) => {
    let tempCounterpartyList = []
    portfolioData.forEach(data => {
        if (data.isChecked === true) {
            tempCounterpartyList.push(data.counterpartyId);
        }
    })

    return tempCounterpartyList;
}

export const setInitialValues = (dashboardFilters) => {
    let tempInitialValues = {}
    const tempCounterPartyInital = counterPartyInitialValues(dashboardFilters);
    const tempCaseStatusInitial = caseStatusInitialValues(dashboardFilters);
    const tempZoneInitial = zoneInitialValues(dashboardFilters);
    const templegalConstitutionInitial = legalContitutionInitialValues(dashboardFilters);
    const tempProductNameInitial = productNameInitialValues(dashboardFilters);
    const tempRiskTrendInitial = riskTrendInitialValues(dashboardFilters);
    const tempRiskLevelInitial = riskLevelInitialValues(dashboardFilters);
    const tempBusinessSegmentInitial = businessSegmentInitialvalues(dashboardFilters);
    tempInitialValues = Object.assign({},
        tempCounterPartyInital,
        tempCaseStatusInitial,
        tempZoneInitial,
        templegalConstitutionInitial,
        tempProductNameInitial,
        tempRiskTrendInitial,
        tempRiskLevelInitial,
        tempBusinessSegmentInitial
    )
    return tempInitialValues;
}

const counterPartyInitialValues = (dashboardFilters) => {
    let tempCounterPartyFilter = {}
    if (dashboardFilters.counterpartyFilter) {
        dashboardFilters.counterpartyFilter.forEach((item, index, element) => {
            tempCounterPartyFilter[item] = true
        })
    }
    return tempCounterPartyFilter
}
const caseStatusInitialValues = (dashboardFilters) => {
    let tempCaseStatusFilter = {}
    if (dashboardFilters.caseStatusFilter) {
        dashboardFilters.caseStatusFilter.forEach((item, index, element) => {
            tempCaseStatusFilter[item] = true
        })
    }
    return tempCaseStatusFilter
}
const zoneInitialValues = (dashboardFilters) => {
    let tempZoneFilter = {}
    if (dashboardFilters.zoneFilter) {
        dashboardFilters.zoneFilter.forEach((item, index, element) => {
            tempZoneFilter[item] = true
        })
    }
    return tempZoneFilter
}

const legalContitutionInitialValues = (dashboardFilters) => {
    let tempLegalContitutionFilter = {}
    if (dashboardFilters.legalConstitutionFilter) {
        dashboardFilters.legalConstitutionFilter.forEach((item, index, element) => {
            tempLegalContitutionFilter[item] = true
        })
    }
    return tempLegalContitutionFilter
}
const productNameInitialValues = (dashboardFilters) => {
    let tempProductNameFilter = {}
    if (dashboardFilters.productNameFilter) {
        dashboardFilters.productNameFilter.forEach((item, index, element) => {
            tempProductNameFilter[item] = true
        })
    }
    return tempProductNameFilter
}
const riskTrendInitialValues = (dashboardFilters) => {
    let tempRiskScoreTrendFilter = {}
    if (dashboardFilters.riskScoreTrendFilter) {
        dashboardFilters.riskScoreTrendFilter.forEach((item, index, element) => {
            tempRiskScoreTrendFilter[item] = true
        })
    }
    return tempRiskScoreTrendFilter
}
const riskLevelInitialValues = (dashboardFilters) => {
    let tempRiskLevelFilter = {}
    if (dashboardFilters.riskLevelFilter) {
        dashboardFilters.riskLevelFilter.forEach((item, index, element) => {
            tempRiskLevelFilter[item] = true
        })
    }
    return tempRiskLevelFilter
}
const businessSegmentInitialvalues = (dashboardFilters) => {
    let tempBusinessSegmentFilter = {}
    if (dashboardFilters.businessSegmentFilter) {
        dashboardFilters.businessSegmentFilter.forEach((item, index, element) => {
            tempBusinessSegmentFilter[item] = true
        })
    }
    return tempBusinessSegmentFilter
}

export const checkDuplicateCounterParty = (selectedPortfolioData) => {
    return selectedPortfolioData.map((e) => {
        return e.counterpartyType
    }).every(checkCounterPartyTypeDuplicate)
}

function checkCounterPartyTypeDuplicate(selectedCounterpartyType, index, selectedPortfolioData) {
    return (selectedCounterpartyType === selectedPortfolioData[0])
}
export const checkDuplicateZone = (selectedPortfolioData) => {
    return selectedPortfolioData.map((e) => {
        return e.zoneName
    }).every(checkZoneDuplicate)
}

function checkZoneDuplicate(selectedZone, index, selectedPortfolioData) {
    return (selectedZone === selectedPortfolioData[0])
}

export const paginatedRequestBody = (pageNo, pageSize, sortField, sortType, filters) => {
    return {
        paginateData: {
            pageNo: pageNo,
            pageSize: pageSize,
            sortField: sortField,
            sortType: sortType
        },
        requestData: filters
    }
}
export const pageLink = css({
    margin: '5px',
    cursor: 'pointer',
    display: 'inline-block',
    padding: '10px',
    WebkitBorderRadius: '20px',
    MozBorderRadius: '20px',
    borderRadius: '0px',
    textTransform: 'capitalize',
})

export const currentLink = css({
    backgroundColor: '#dceaf9',
    display: 'inline-block',
    cursor: 'pointer',
    color: '#FFFFFF',
    'a:link': { color: '#FFFFFF' },
    'a:visited': { color: '#FFFFFF' },
    'a:active': { color: '#FFFFFF' }
})

export const createFilterUrl = (filterFormData, toDate, fromDate, selectedCountry, selectedState) => {
    let url = new URLSearchParams();
    Object.keys(filterFormData).forEach(data => {
        if (filterFormData[data]) {
            if (filterFormData[data].length > 0) {
                url.set(data, encodeURIComponent(filterFormData[data].toString()))
            }
        }
    })
    if (toDate && fromDate) {
        url.set('dateRange', moment(fromDate).format(DATE_FORMAT) + 'to' + moment(toDate).format(DATE_FORMAT))
    }
    if (selectedCountry) {
        url.set('selectedCountry', encodeURIComponent(selectedCountry))
    }
    if (selectedState) {
        const tempStateData = [];
        selectedState.forEach((item) => {
            tempStateData.push(encodeURIComponent(item.label))
        })
        url.set('selectedState', (tempStateData).toString())
    }
    return decodeURIComponent(url)
}

export const getUrlFilter = (urlFilters) => {
    const params = new URLSearchParams(urlFilters);
    const tempFilters = {
        counterpartyType: params.get('counterpartyType') ? (params.get('counterpartyType')).split(',') : [],
        reportType: params.get('reportType') ? (params.get('reportType')).split(',') : [],
        riskLevel: params.get('riskLevel') ? (params.get('riskLevel')).split(',') : [],
        region: params.get('region') ? (params.get('region')).split(',') : [],
        classOfCompany: params.get('classOfCompany') ? (params.get('classOfCompany')).split(',') : [],
        businessSegment: params.get('businessSegment') ? (params.get('businessSegment')).split(',') : [],
        nicSegment: params.get('nicSegment') ? (params.get('nicSegment')).split(',') : [],
        caseStatus: params.get('caseStatus') ? (params.get('caseStatus')).split(',') : [],
        riskTrend: params.get('riskTrend') ? (params.get('riskTrend')).split(',') : [],
        fromDate: params.get('dateRange') ? (params.get('dateRange')).split('to')[0] : null,
        toDate: params.get('dateRange') ? (params.get('dateRange')).split('to')[1] : null,
        selectedCountry: params.get('selectedCountry') ? (params.get('selectedCountry')).split(',') : [],
        selectedState: params.get('selectedState') ? (params.get('selectedState')).split(',') : [],
        caseType: params.get('caseType') ? (params.get('caseType')).split(',') : [],
        productTypes : params.get('productTypes') ? params.get('productTypes').split(',') :[]
    }
    return tempFilters
}
/* function setParams(query, queryType, url) {
    const searchParams = new URLSearchParams();
    if (url) {
        searchParams.set(queryType, query.toString())
        searchParams.append(queryType, query)
    } else {
        searchParams.set(queryType, query.toString());
    }
    return searchParams.toString();
} */

/* reportType: (filterFormData.productNameFilter.length > 0) ? `${filterFormData.productNameFilter}` : '',
        riskLevel: (filterFormData.riskLevel.length > 0) ? `${filterFormData.riskLevelFilter}` : '',
        region: (filterFormData.region.length > 0) ? `${filterFormData.zoneFilter}` : '',
        classOfCompany: (filterFormData.classOfCompany.length > 0) ? `${filterFormData.legalConstitutionFilter}` : '',
        businessSegment: (filterFormData.businessSegment.length > 0) ? `${filterFormData.businessSegmentFilter}` : '',
        caseStatus: (filterFormData.caseStatus.length > 0) ? `${filterFormData.caseStatusFilter}` : '',
        riskTrend: (filterFormData.riskTrend.length > 0) ? `${filterFormData.riskScoreTrendFilter}` : '',
        dateRange: (fromDate && toDate) ? `${fromDate + '-' + toDate}` : '', */